import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// third party
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './constants/authConfig';
// project imports
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import './index.scss';
import { USER_TYPE } from './constants';
import useAuthExternalUser from './hooks/useAuthExternalUser';
const root = ReactDOM.createRoot(document.getElementById('root'));
// Define a wrapper component to conditionally choose between Auth0 and MSAL
const AuthProviderWrapper = () => {
  const { getUserType, externalUserLogout } = useAuthExternalUser();
  const userType = getUserType();
  const urlParams = new URLSearchParams(window.location.search);
  const clientId = urlParams?.get('client_id');
  const code = urlParams?.get('code');
  const error = urlParams?.get('error');
  if(clientId && code){
    sessionStorage.setItem('userType', USER_TYPE.externalUser);
  }else if(error){
    externalUserLogout();
  }else if(userType === undefined || userType === null){
    sessionStorage.setItem('userType', USER_TYPE.internalUser);
  }
  if (clientId && code) {
     // If user is External
     return (
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    );
  } else {
    // If user is internal, use MSAL
    return (
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </MsalProvider>
    );
  }
};

root.render(
  <React.StrictMode>
    <AuthProviderWrapper />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
